import { GetterTree } from "vuex";

import { FriendsState } from "./types";
import { RootState } from "../../types";
import { FriendRef } from "@dokogd/shared";

const getFriends = "getFriends";

const n = {
  getFriends,
};

export const getters: GetterTree<FriendsState, RootState> = {
  [n.getFriends](state): FriendRef[] {
    return state.friends;
  },
};

export const getterNames = n;
